import React, { useState } from 'react'
import { Form, Input, Button, Row, Col, message, Image } from 'antd'
import firebase from 'firebase'
import './index.css'

const StoreCard = ({ store, updatePharmacyStore }) => {
  const [isEdit, setIsEdit] = useState(false)
  const [formData, setFormData] = useState(false)
  const [image, setImage] = useState(false)
  const fallback = 'data:image/png;base64,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'
  const [form] = Form.useForm()

  const validateMessages = {
    required: 'กรุณากรอก${label}'
  }

  const onFinish = values => {
    setIsEdit(!isEdit)
    if (formData) {
      if (image) {
        values.image = image
      }
      const jsonFormData = JSON.stringify(formData)
      const jsonValues = JSON.stringify(values)
      if (jsonFormData !== jsonValues) {
        updatePharmacyStore(values)
      }
      setFormData(false)
    } else {
      setFormData(values)
    }
  }

  const handleChangeProfileImage = e => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files[0].size > 2097152) {
        message.error('เกิดข้อผิดพลาด กรุณาอัปโหลดรูปภาพที่มีขนาดไม่เกิน 2MB')
      } else {
        const { REACT_APP_NODE } = process.env
        const fileUpload = e.target.files[0]
        const fileName = e.target.files[0].lastModified.toString()
        const storageRef = firebase.storage().ref(`pharmacy-store/${REACT_APP_NODE}/${fileName}`)
        const task = storageRef.put(fileUpload)
        message.warning('กำลังอัปโหลดรูปภาพ')
        task.on(
          'state_changed',
          snapshort => {
            // let percentage = (snapshort.bytesTransferred / snapshort.totalBytes) * 100
            // Process
          },
          error => {
            // Error
            message.error(error.message)
          },
          async () => {
            // Success
            message.success('อัปโหลดรูปสำเร็จ')
            const storageImage = await storageRef.getDownloadURL()
            setImage(storageImage)
          }
        )
      }
    }
  }

  return (
    <div className="storeCard">
      <Form
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        name="nest-messages"
        style={{ maxWidth: '100%' }}
        onFinish={onFinish}
        validateMessages={validateMessages}
        initialValues={{
          name: store.name,
          address: store.address,
          detail: store.detail
        }}
      >
        <label htmlFor="upload-button">
          {isEdit ? (
            <Image
              width={200}
              height={200}
              style={{ cursor: 'pointer' }}
              src={image || 'error'}
              fallback={!image && fallback}
            />
          ) : (
            <img style={{ width: 200, width: 200 }} src={store.image} alt="" />
          )}
        </label>
        {isEdit ? (
          <input
            type="file"
            accept="image/png, image/jpeg"
            id="upload-button"
            style={{ display: 'none' }}
            onChange={handleChangeProfileImage}
          />
        ) : null}
        <Form.Item name="name" label="ชื่อร้าน">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name={['detail','description']} label="รายละเอียด">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name={['detail','time']} label="เวลาทำการ">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name="address" label="ที่อยู่">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name={['detail','phone']} label="เบอร์">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name={['detail','email']} label="อีเมล">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item name={['detail','website']} label="เว็บไซต์">
          <Input disabled={!isEdit} />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 24 }} className="text-right">
          <Button type="primary" htmlType="submit">
            {isEdit ? 'บันทึก' : 'แก้ไข'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default StoreCard
